@use './skeleton-vars';
@use './skeleton-common';
@use './skeleton-utility';

:host {
  @include skeleton-vars.wb-skeleton-vars;
  @include skeleton-common.wb-skeleton;
}

:host([is-rtl]) {
  @include skeleton-vars.wb-skeleton-rtl-vars;
  @include skeleton-common.wb-skeleton-rtl;
}
